import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Client } from '@df/core/service/client';
import { Giftcards } from '@df/module-giftcards/giftcards';
import { nl2br } from '@df/ui/common/nl2br.pipe';

interface IRow {
    title: string;
    value?: string;
    text?: string;
    html?: boolean;
}
@Component({
    selector: 'giftcards-basket-details',
    templateUrl: 'giftcards-basket-details.html',
    styleUrls: ['giftcards-basket-details.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GiftcardsBasketDetailsComponent {
    @Input()
    request?: Giftcards.IAddToBasketData;

    constructor(protected client: Client) {}

    get rows(): IRow[] {
        const rows: IRow[] = [{ title: 'Sending to', value: this.request?.am_giftcard_recipient_email || '', text: 'Myself' }];
        if (this.request?.am_giftcard_recipient_email) {
            rows.push(
                { title: 'Name', value: this.request.am_giftcard_recipient_name || '' },
                { title: 'From', value: this.request.am_giftcard_sender_name || '' },
                { title: 'Message', value: `“${nl2br(this.request.am_giftcard_message || '')}”`, html: true }
            );
        }
        rows.push({ title: 'Send date', value: this.request?.am_giftcard_date_delivery as string, text: 'Immediately' });

        return rows;
    }
}
